import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DataTestID, lang } from 'src/utils';

import { showLoginSelectWidget } from './LoginSelect.helper';
import { ILoginSelectProps } from './LoginSelect.interface';
import { AuthLockWrapper } from './LoginSelect.styled';

const COATES_LOGO_URL =
  'https://cdn.switchboardcms.com/sb-icon-suite/v1/Coates-Logo-Colour.png';

export const LoginSelect = ({ environment }: ILoginSelectProps) => {
  useEffect(() => {
    showLoginSelectWidget(environment);
  }, [environment]);

  const [sp] = useSearchParams();
  const hasError =
    sp.get('authError') ||
    sp.get('error') ||
    new URLSearchParams(window.location.search).get('error');

  const handleLegacyLogin = useCallback(() => {
    const mtUI = environment?.urls.mtUI ?? '';
    if (!mtUI) return;

    window.location.assign(`${mtUI}/home/#/login/`);
  }, [environment]);

  return (
    <Grid
      height="100vh"
      display="flex"
      flexDirection="row"
      justifyContent="center"
      alignItems="center">
      <Grid sx={{ borderTop: `5px solid #1686E2`, borderRadius: 1 }}>
        <AuthLockWrapper>
          <Stack alignItems="center">
            {hasError && (
              <Box
                sx={{
                  backgroundColor: '#FF0000',
                  width: '100%',
                  p: 1,
                  textAlign: 'center',
                }}
                data-testid={DataTestID.Auth0LockContainerError}>
                <Typography textTransform="uppercase" color="#fff">
                  {lang.loginPageErrorOccurred}
                </Typography>
              </Box>
            )}
            <Box
              id="auth0-lock-container"
              data-testid={DataTestID.Auth0LockContainer}
            />
            <Button
              size="large"
              color="primary"
              endIcon={<ChevronRightRoundedIcon />}
              startIcon={
                <Box
                  component="img"
                  src={COATES_LOGO_URL}
                  alt="Coates"
                  sx={{
                    width: 28,
                    height: 28,
                    borderRadius: 1.5,
                    bgcolor: '#fff',
                    p: 0.5,
                  }}
                />
              }
              sx={{
                minWidth: '100%',
                borderRadius: '0 0 5px 5px',
                minHeight: '70px',
                backgroundColor: '#1686E2',
              }}
              onClick={handleLegacyLogin}
              data-testid={DataTestID.CoatesLoginButton}>
              {lang.coatesLogin}
            </Button>
          </Stack>
        </AuthLockWrapper>
      </Grid>
    </Grid>
  );
};
